import React from "react";
import styled from "styled-components";
import { GAME_STATES, SUBSCRIPTIONS } from "../../CoreLoop";

const TimeRemainingBar = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 16px;
  background-color: var(--color-amber-500);
  transform: scaleY(var(--time-remaining));
  transform-origin: bottom;
  opacity: var(--opacity);
  transition:
    transform 0.05s linear,
    opacity 0.25s ease-in-out;
`;

function TimeRemaining({ coreLoop }) {
  const [timeRemaining, setTimeRemaining] = React.useState(1);
  const [gameState, setGameState] = React.useState(GAME_STATES.FIRST_PAGE_LOAD);
  const id = React.useId();
  React.useEffect(() => {
    coreLoop.current.subscribe(SUBSCRIPTIONS.TIME_REMAINING, id, (data) => {
      setTimeRemaining(data);
    });
    coreLoop.current.subscribe(SUBSCRIPTIONS.GAME_STATE_CHANGED, id, (data) => {
      setGameState(data);
    });
    return () => {
      coreLoop.current.unsubscribe(SUBSCRIPTIONS.TIME_REMAINING, id);
      coreLoop.current.unsubscribe(SUBSCRIPTIONS.GAME_STATE_CHANGED, id);
    };
  }, [id]);
  const opacity = React.useMemo(() => {
    if (gameState === GAME_STATES.RUNNING_GAME) return 1;
    else return 0;
  }, [gameState]);

  return (
    <TimeRemainingBar
      style={{ "--time-remaining": timeRemaining, "--opacity": opacity }}
    />
  );
}

export default TimeRemaining;
